import $ from 'jquery';
import BaseGateway from './BaseGateway';

class LocalPaymentGateway extends BaseGateway {

    elementType = 'payment';

    constructor(props) {
        super(props);
        this.capabilities.push('place_order_button', 'checkout_error');
    }

    async mountPaymentElement(container) {
        this._elementsSubmitted = false;
        this.paymentElement.removeAllListeners();
        this.paymentElement.on('change', this.onPaymentElementChange.bind(this));
        this.paymentElement.on('loaderror', this.onPaymentElementLoadError.bind(this, container));
        this.paymentElement.mount(container);
    }

    async validatePaymentElement() {
        try {
            let response = await this.elements.submit();
            if (response.error) {
                throw response.error;
            }
            this._elementsSubmitted = true;
        } catch (error) {
            throw error;
        }
    }

    onPaymentElementChange(event) {
        if (event?.value?.type) {
            this.paymentMethodType = event.value.type;
        }
    }

    onPaymentElementLoadError(container, event) {
        const {error} = event;
        this.elements = null;
        this.paymentElement = null;
        $(container).append(error.message);
    }

    hasPaymentMethodId() {
        return this._elementsSubmitted;
    }

}

export default LocalPaymentGateway;